import { useTranslator } from '@jutro/locale';
import PropTypes from 'prop-types';
import React, { Fragment } from 'react';
import styles from './ActivityAdvancedFilter.module.scss';
import { CheckboxField } from '@jutro/legacy/components';

const FilterOptions = props => {
    const { filters, onValueChange } = props;
    const writeValue = (value, path) => {
        filters.options[path].selected = value;
        if (onValueChange) {
            onValueChange(filters);
        }
    };
    const translator = useTranslator();
    return (
        <Fragment>
            {filters.options.map((option, index) => {
                const fieldId = option.displayKey.id || option.displayKey;
                return (
                    <div className={styles.gwFilterOption} key={fieldId}>
                        <CheckboxField
                            id={fieldId}
                            value={option.selected}
                            path={index}
                            showInlineLabel
                            label={translator(option.displayKey)}
                            showOptional={false}
                            onValueChange={writeValue}
                            labelClassName={styles.gwActivityFilterOptionsLabel}
                        />
                    </div>
                );
            })}
        </Fragment>
    );
};

FilterOptions.propTypes = {
    filters: PropTypes.shape({
        options: PropTypes.shape([]),
    }).isRequired,
    onValueChange: PropTypes.func.isRequired,
};
export default FilterOptions;
